import React from "react";
import { useSelector } from "react-redux";
import { selectHasActiveGlobalAccount } from "../../../../redux/slices/registrationAccountSlice";
import AccountCTAAccountForm from "./AccountCTAAccountForm";

const ConnectedAccountCTAAccountForm = () => {
    const hasActiveGlobalAccount = useSelector(selectHasActiveGlobalAccount);
    return (
        <AccountCTAAccountForm
            hasActiveGlobalAccount={hasActiveGlobalAccount}
        />
    );
};

export default ConnectedAccountCTAAccountForm;
